import { Stack } from '@mui/material';
import { GeneralListLayout } from 'components/layouts';
import { useI18n } from 'locales';
import { useCallback, useState } from 'react';
import PortalHeader from '../components/PortalHeader';
import SubscriptionDetailsDialog from './components/SubscriptionDetailsDialog';

const defaultListParams = {
  sort: 'nextBillingTime',
  order: 'asc',
};

function PortalSubscriptionPage() {
  const t = useI18n();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const onClickViewHandler = useCallback((row) => {
    setSelectedId(row.id);
    setOpenDialog(true);
  }, []);

  const onCloseDialogHandler = useCallback(() => {
    setOpenDialog(false);
    setSelectedId(null);
  }, []);

  return (
    <>
      <PortalHeader header={t('SUBSCRIPTIONS')} />

      <Stack gap={2} sx={{ px: 2, py: 3 }}>
        <GeneralListLayout
          model="Subscription"
          title={t('Recurring Instructions')}
          defaultListParams={defaultListParams}
          onView={onClickViewHandler}
        />
      </Stack>

      <SubscriptionDetailsDialog
        open={openDialog}
        onClose={onCloseDialogHandler}
        subscriptionId={selectedId}
      />
    </>
  );
}

export default PortalSubscriptionPage;
